import { postRequest, getRequest } from './requestClient';


export function login(params: AppAPI.LoginParams) {
  return postRequest<AppAPI.LoginResponse>('/auth/login', params);
}

export function getCurrentUser() {
  return getRequest<AppAPI.GetUserResponse>('/auth/me');
}

export function logout() {
  return postRequest<AppAPI.Response<null>>('/auth/logout');
}

export function register(params: AppAPI.RegisterParams) {
  return postRequest<AppAPI.Response<null>>('/auth/register', params);
}
